/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';
import type { WorkplacePreference } from './';
import {
    WorkplacePreferenceFromJSON,
    WorkplacePreferenceFromJSONTyped,
    WorkplacePreferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateLocationAndWorkplaceRequest
 */
export interface UpdateLocationAndWorkplaceRequest {
    /**
     * 
     * @type {PostalAddress}
     * @memberof UpdateLocationAndWorkplaceRequest
     */
    location: PostalAddress;
    /**
     * 
     * @type {WorkplacePreference}
     * @memberof UpdateLocationAndWorkplaceRequest
     */
    workplacePreference: WorkplacePreference;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLocationAndWorkplaceRequest
     */
    willingnessToTravelInternationally?: boolean;
}

/**
 * Check if a given object implements the UpdateLocationAndWorkplaceRequest interface.
 */
export function instanceOfUpdateLocationAndWorkplaceRequest(value: object): value is UpdateLocationAndWorkplaceRequest {
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('workplacePreference' in value) || value['workplacePreference'] === undefined) return false;
    return true;
}

export function UpdateLocationAndWorkplaceRequestFromJSON(json: any): UpdateLocationAndWorkplaceRequest {
    return UpdateLocationAndWorkplaceRequestFromJSONTyped(json, false);
}

export function UpdateLocationAndWorkplaceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLocationAndWorkplaceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'location': PostalAddressFromJSON(json['location']),
        'workplacePreference': WorkplacePreferenceFromJSON(json['workplacePreference']),
        'willingnessToTravelInternationally': json['willingnessToTravelInternationally'] == null ? undefined : json['willingnessToTravelInternationally'],
    };
}

export function UpdateLocationAndWorkplaceRequestToJSON(value?: UpdateLocationAndWorkplaceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'location': PostalAddressToJSON(value['location']),
        'workplacePreference': WorkplacePreferenceToJSON(value['workplacePreference']),
        'willingnessToTravelInternationally': value['willingnessToTravelInternationally'],
    };
}

